import React, { useEffect } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import Loader from "./../../../shared/loader";
import { fetchAnimals } from "./ducks/actions";
import AddIcon from "../../icons/add";
import List from "./list";
import ScrollIntoView from "../../../shared/scroll-into-view/scroll-into-view";

function ListAnimalsContainer(props) {
    const filmId = props.match.params.filmId;
    const { fetchAnimals, loading, animals, errors, readOnly } = props;

    useEffect(() => {
        fetchAnimals(filmId);
    }, []);

    function renderLoading() {
        return <Loader />;
    }

    function renderAnimals(animals, filmId) {
        return (
            <ScrollIntoView
                className="blade-menu"
                path="/films/:filmId/animals/overview"
                loading={loading}>
                <List animalItems={animals} filmId={filmId} />
                {!readOnly && !window.location.pathname.endsWith("add") && <NavLink
                    to={`/films/${filmId}/animals/add`}
                    activeClassName={
                        "is-active " + window.location.pathname.endsWith("add")
                            ? "disabled"
                            : ""
                    }
                    className="button is-transparent is-add">
                    <AddIcon className="white-icon" />
                    Add Animal
                </NavLink>}
            </ScrollIntoView>
        );
    }

    return loading ? renderLoading() : renderAnimals(animals, filmId);
}

function mapStateToAnimals(state) {
    const { animals, loading, errors, readOnly } = state.animalsState;
    return { animals, loading, errors, readOnly };
}

export default connect(mapStateToAnimals, {
    fetchAnimals
})(ListAnimalsContainer);
